import React from "react";
import { Subscription } from "react-apollo";
import MachineStatus from "components/MachineStatus/MachineStatus";
import { PlantItem } from "components/StyledComponents";
import SUBSCRIBE_TO_ACTUATOR_CHANGES from "../graphql/subscriptions/subscribeToActuatorStatusChanges.js";

const ActuatorSubscription = ({
  automationStatus,
  id,
  name,
  status,
  type,
  maintenanceMode,
}) => (
  <Subscription
    subscription={SUBSCRIBE_TO_ACTUATOR_CHANGES}
    fetchPolicy="no-cache"
    variables={{
      id
    }}
  >
    {({ data }) => (
      <PlantItem>
        <MachineStatus
          automationStatus={automationStatus}
          status={data ? data.subscribeToActuatorStatusChanges : (false || status)}
          actuatorName={name}
          id={id}
          type={type}
          maintenanceMode={maintenanceMode}
        />
      </PlantItem>
    )}
  </Subscription>
);

export default ActuatorSubscription;
